import { Component } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { ExistingOrderMobileComponent } from './existing-order-mobile/existing-order-mobile.component';
import { StartNewOrderMobileComponent } from './start-new-order-mobile/start-new-order-mobile.component';
import { AddToOrderBaseComponent } from '../add-to-order-base.component';
import { DatePipe } from '@angular/common';
import { ModalService } from '@shared/services/modal/modal.service';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from '@order/services/order.service';
import { PopoverHelperService } from '@shared/helpers/popover.helpers';
import { OrderHeader, OrderItem } from '@usf/ngrx-order';
import { UserService } from '@app/user/services';

@Component({
  selector: 'app-add-to-order-modal-mobile',
  templateUrl: './add-to-order-modal-mobile.component.html',
  styleUrls: ['./add-to-order-modal-mobile.component.scss'],
})
export class AddToOrderModalMobileComponent extends AddToOrderBaseComponent {
  currentTab = 1;

  constructor(
    nav: IonNav,
    datePipe: DatePipe,
    modalController: ModalController,
    modalService: ModalService,
    orderService: OrderService,
    popoverHelperService: PopoverHelperService,
    translate: TranslateService,
    platformService: PlatformService,
    panAppState: PanAppState,
    fb: FormBuilder,
    userService: UserService,
  ) {
    super(
      nav,
      datePipe,
      modalController,
      modalService,
      orderService,
      popoverHelperService,
      translate,
      platformService,
      panAppState,
      fb,
      userService,
    );
  }

  async closeModal() {
    const modData = {
      orderHeader: this.orderHeader,
      origOrderItems: this.origOrderItems,
      updateOrderItem: this.updateOrderItem,
    };
    this.orderService.cancelAddToOrderModal(modData);
    await this.modalController.dismiss();
  }

  toggleTab(tab: number) {
    if (this.currentTab !== tab) {
      this.currentTab = tab !== 2 ? 1 : 2;
    }
  }

  async goToStartNewOrder() {
    const defaultPoNumber = await super.loadDefaultPoNumber().toPromise();
    let tabData: {
      currentTab: number;
      nextDeliveryDate: string | Date;
      orderHeader: OrderHeader;
      origOrderItems: OrderItem[];
      updateOrderItem: OrderItem;
      isCustomerRequirePO: boolean;
      disablePO: boolean;
      defaultPoNumber: string;
      saveDefaultPoNumber: (poNumber: string) => Promise<void>;
      isPoDisabledForVPTAndPunchOut: boolean;
    } = {
      currentTab: this.currentTab,
      nextDeliveryDate: this.nextDeliveryDate,
      orderHeader: this.orderHeader,
      origOrderItems: this.origOrderItems,
      updateOrderItem: this.updateOrderItem,
      isCustomerRequirePO: this.isCustomerRequirePO,
      disablePO: this.disablePO,
      defaultPoNumber: defaultPoNumber,
      saveDefaultPoNumber: this.saveDefaultPoNumber.bind(this),
      isPoDisabledForVPTAndPunchOut: this.isPoDisabledForVPTAndPunchOut,
    };
    this.nav.push(StartNewOrderMobileComponent, { data: tabData });
  }

  goToAddToExistingOrder() {
    let tabData: {
      currentTab: number;
      orderHeader: OrderHeader;
      origOrderItems: OrderItem[];
      updateOrderItem: OrderItem;
    } = {
      currentTab: this.currentTab,
      orderHeader: this.orderHeader,
      origOrderItems: this.origOrderItems,
      updateOrderItem: this.updateOrderItem,
    };
    this.nav.push(ExistingOrderMobileComponent, { data: tabData });
  }
}
